import { axiosInstanceWebsite } from "../instance";
import { cachedRequest } from "../../utils/requestCache";
import { decodeTokenService } from "../decodeTokenService";
import type { CreditHistoryResponse } from "../../types/membership";

const MEMBERSHIP_TTL_MS = 60_000;
const membershipCacheKey = (scope: string) =>
    `membership:${decodeTokenService.getUserIdFromToken() || "anonymous"}:${scope}`;

export const membershipAxios = async () => {
    return cachedRequest(membershipCacheKey("active"), MEMBERSHIP_TTL_MS, async () => {
        const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/user/active`, { timeout: 20_000 });
        return response.data;
    });
};

export const membershipStatsAxios = async () => {
    return cachedRequest(membershipCacheKey("stats"), MEMBERSHIP_TTL_MS, async () => {
        const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/user/stats`, { timeout: 20_000 });
        return response.data;
    });
};

export const creditHistoryAxios = async (
    limit = 20,
    cursor?: string | null
): Promise<CreditHistoryResponse> => {
    const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/me/credits/history`, {
        params: {
            limit,
            ...(cursor ? { cursor } : {}),
        },
        timeout: 20_000,
    });
    return response.data;
};

export const getTypesPlans = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/membership`);
    return response.data;
};

export const getCancelStatus = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/cancel/status`);
    return response.data;
};

export const cancelMembership = async (reason: string) => {
    const response = await axiosInstanceWebsite.put(`/subscription/user-memberships/cancel`, {
        reason: reason
    });
    return response.data;
};

export const getIsEligibleDowngradeLite = async () => {
    const response = await axiosInstanceWebsite.get(`/subscription/user-memberships/downgrade-lite/eligibility`);
    return response.data;
};

export const postDowngradeLite = async () => {
    const response = await axiosInstanceWebsite.post(`/subscription/user-memberships/downgrade-lite`);
    return response.data;
};
